import React from 'react';
import { Sheet, SheetContent, SheetTitle } from '@/components/ui/sheet';
import { cn } from '@/lib/utils';

export default function DirectorStudioLayout({
    sidebar,
    stage,
    properties,
    sidebarTitle = 'Story Stream',
    propertiesTitle = 'Scene Properties',
    sidebarMobileOpen = false,
    onSidebarMobileOpenChange,
    propertiesMobileOpen = false,
    onPropertiesMobileOpenChange,
    propertiesCollapsed = false,
    className,
}) {
    return (
        <div className={cn('flex h-full min-h-0 flex-1 overflow-hidden', className)}>
            {sidebar ? (
                <aside className="hidden min-h-0 w-[320px] shrink-0 overflow-hidden border-r border-border bg-card lg:flex xl:w-[350px] 2xl:w-[360px]">
                    {sidebar}
                </aside>
            ) : null}

            <div className="min-h-0 min-w-0 flex-1 overflow-hidden bg-muted/40">
                {stage}
            </div>

            {!propertiesCollapsed && properties ? (
                <aside className="hidden min-h-0 w-[340px] shrink-0 overflow-hidden border-l border-border bg-card lg:flex xl:w-[360px] 2xl:w-[380px]">
                    {properties}
                </aside>
            ) : null}

            {sidebar ? (
                <Sheet open={sidebarMobileOpen} onOpenChange={onSidebarMobileOpenChange}>
                    <SheetContent
                        side="left"
                        showCloseButton={false}
                        className="w-[min(100vw,24rem)] max-w-[24rem] gap-0 border-r border-border bg-card p-0 sm:max-w-[24rem]"
                    >
                        <SheetTitle className="sr-only">{sidebarTitle}</SheetTitle>
                        {sidebar}
                    </SheetContent>
                </Sheet>
            ) : null}

            {properties ? (
                <Sheet open={propertiesMobileOpen} onOpenChange={onPropertiesMobileOpenChange}>
                    <SheetContent
                        side="right"
                        showCloseButton={false}
                        className="w-[min(100vw,26rem)] max-w-[26rem] gap-0 border-l border-border bg-card p-0 sm:max-w-[26rem]"
                    >
                        <SheetTitle className="sr-only">{propertiesTitle}</SheetTitle>
                        {properties}
                    </SheetContent>
                </Sheet>
            ) : null}
        </div>
    );
}
